const FrenchDoor = ({ handleTraitChange, trait }) => {
  return (
    <div>
      <p>French Door</p>

      <select
        name="frenchDoor"
        className="form-control mb-3"
        onChange={(e) => handleTraitChange(e)}
        defaultValue={trait.frenchDoor}
      >
        <option value="0">none</option>
        <option value="left">left</option>
        <option value="center">center</option>
        <option value="right">right</option>
      </select>
      <div
        className="row"
        style={{ display: !trait.frenchDoor ? "none" : "flex" }}
      >
        <div className="col">
          <label>Width</label>
          <select
            defaultValue={trait.frenchW}
            className="form-control mb-3"
            name="frenchW"
            onChange={(e) => handleTraitChange(e)}
          >
            <option value="5ft">5ft</option>
            <option value="6ft">6ft</option>
          </select>
          <label>Header</label>
          <select
            defaultValue={trait.frenchHeader / trait.pixels}
            className="form-control mb-3"
            type="number"
            name="frenchHeader"
            onChange={(e) => handleTraitChange(e)}
          >
            <option value="5.5">2 x 6</option>
            <option value="7.25">2 x 8</option>
            <option value="9.25">2 x 10</option>
            <option value="11.25">2 x 12</option>
          </select>
          <label>Header Amount</label>
          <select
            defaultValue={trait.frenchHeaderAmount / trait.pixels}
            className="form-control mb-3"
            type="number"
            name="frenchHeaderAmount"
            onChange={(e) => handleTraitChange(e)}
          >
            <option value="0">SINGLE</option>
            <option value="1">DOUBLE</option>
            <option value="2">TRIPLE</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default FrenchDoor;
